import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=67284ea1&scoped=true&"
import script from "./attachments.vue?vue&type=script&lang=js&"
export * from "./attachments.vue?vue&type=script&lang=js&"
import style0 from "./attachments.vue?vue&type=style&index=0&id=67284ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67284ea1",
  null
  
)

export default component.exports